// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1KSc_","text":"SelectPayment_text__14a40","title":"SelectPayment_title__G9wt7","btn":"SelectPayment_btn__3-dvg"};